export default [
  {
    title: '姓名',
    dataIndex: 'studentName',
    scopedSlots: { customRender: 'studentName' }
  },
  {
    title: '手机号',
    dataIndex: 'phoneNumber',
    scopedSlots: { customRender: text => text || '--' }
  },
  {
    title: '当前权益',
    dataIndex: 'jurisdiction',
    scopedSlots: { customRender: 'jurisdiction' }
  },
  {
    title: '学习机课程',
    dataIndex: 'courseNameStringList',
    scopedSlots: { customRender: 'courseNameStringList' }
  },
  {
    title: '添加来源',
    dataIndex: 'origin',
    scopedSlots: { customRender: 'origin' }
  },
  {
    title: '权益更改',
    dataIndex: 'action',
    width: 350,
    scopedSlots: { customRender: 'action' }
  }
]
